export default function portalConfirm(message)
{
    return confirm(message);
}